<template>
  <div class="container">
    <div class="add-asset row">
      <div class="card-panel">
        <div v-if="totalExistingAssets>0">You have
          <router-link
            :to="{ name: 'ViewAssets', params: { user_id } }"
          >{{ totalExistingAssets > 1 ? `${totalExistingAssets} assets` : `${totalExistingAssets} asset` }}</router-link>&nbsp;listed. Add more using the following form:
        </div>
        <div v-else>Go ahead and add your first asset :)</div>
      </div>
      <div class="card-panel">
        <h5 class="center-align">Add to Stack</h5>
        <form @submit.prevent="addAsset">
          <div>
            <label>Bullion Form:</label>
            <select v-model="asset_class" class="browser-default">
              <option
                v-for="asset_class in asset_classes"
                :value="asset_class"
                :key="asset_class"
              >{{ ucfirst(asset_class) }}</option>
            </select>
          </div>

          <div>
            <label>Type:</label>
            <select v-model="type" class="browser-default">
              <option v-for="type in types" :value="type" :key="type">{{ ucfirst(type) }}</option>
            </select>
          </div>

          <div class="input-field">
            <input placeholder="Quantity in Ounces" type="text" v-model="quantity">
          </div>

          <div class="input-field">
            <input placeholder="Price in Canadian Dollars" type="text" v-model="price">
          </div>

          <div class="center-align">
            <button class="waves-effect waves-light btn-large amber darken-4">Add Asset</button>
          </div>
        </form>
        <div id="feedback" class="center-align">{{ feedback }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import db from "@/firebase/init";
import moment from "moment";
import helpers from "@/helpers/helpers";

export default {
  name: "AddAssets",
  data() {
    return {
      user_id: this.$route.params.user_id,
      feedback: null,
      asset_class: "gold",
      type: "bar",
      asset_classes: ["gold", "silver"],
      types: ["bar", "coin"],
      quantity: null,
      price: null,
      date_recorded: moment().unix(),
      totalExistingAssets: 0
    };
  },
  methods: {
    ucfirst: str => helpers.ucfirst(str),
    addAsset() {
      this.feedback = null;
      if (this.asset_class === null) {
        this.feedback = "Please select the form of bullion.";
      } else if (this.type === null) {
        this.feedback = "Please select the type of bullion.";
      } else if (this.quantity <= 0) {
        this.feedback = "Please enter a quantity.";
      } else if (this.price <= 0) {
        this.feedback = "Please provide the price of this bullion.";
      } else {
        let id = 1;
        db.collection("assets")
          .add({
            id: this.user_id,
            asset_class: this.asset_class,
            type: this.type,
            quantity: this.quantity,
            price: this.price,
            date_recorded: this.date_recorded
          })
          .then(() => {
            this.$router.push(`/view/${this.user_id}`);
          });
      }
    },
    updateID() {
      this.user_id = this.$route.params.user_id;
    }
  },
  created() {
    // get count of total results
    db.collection("assets")
      .where("id", "==", this.user_id)
      .get()
      .then(snapshot => {
        this.totalExistingAssets = snapshot.docs.length;
      });
  },
  watch: {
    $route: "updateID"
  }
};
</script>


<style scoped>
.container .card-panel {
  margin-top: 20px;
}
.container .row {
  margin: 0 auto;
}
select {
  border: 1px solid #ccc;
  overflow: hidden;
}
input[type="text"] {
  max-width: 180px;
}
.container {
  max-width: 30%;
}
#feedback {
  padding: 10px;
  height: 20px;
  color: #f00;
}
h5 {
  color: #ff6f00;
}

@media screen and (max-width: 992px) {
  .container {
    max-width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddAssets.vue